// Libs
import React, { ReactElement } from 'react';
import { Skeleton } from 'ui-components';

import styles from './content-card-body.module.scss';

/**
 * Skeleton for content card body
 * @param props the props
 */
const ContentCardBodySkeleton = (props: { animation?: false | 'pulse' | 'wave' }): ReactElement => {
  const { animation } = props;

  return (
    <div className={styles.container}>
      <Skeleton variant="text" width="5%" animation={animation} />
      <Skeleton variant="text" width="15%" animation={animation} />
    </div>
  );
};

export default ContentCardBodySkeleton;
